import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const serviceKF: AppRouteModule = {
  path: '/service',
  name: 'Service',
  component: LAYOUT,
  meta: {
    orderNo: -50,
    icon: 'ant-design:phone-outlined',
    title: '客服管理',
  },
  children: [
    {
      path: 'restStrategy',
      name: 'RestStrategy',
      component: () => import('/@/views/service/RestStrategy.vue'),
      meta: {
        title: '客服休息策略',
        icon: 'ant-design:schedule-outlined'
      },
    },
    {
      path: 'linkGroup',
      name: 'LinkGroup',
      component: () => import('/@/views/service/LinkGroup.vue'),
      meta: {
        title: '接线组',
        icon: 'ant-design:team-outlined'
      },
    },
    {
      path: '/session/conditionMonitor',
      name: 'ConditionMonitor',
      component: () => import('/@/views/sessionSettings/conditionMonitor/ConditionMonitor.vue'),
      meta: {
        // affix: true,
        title: '客服状态监控',
        icon: 'ant-design:control-outlined'
      },
    },
    {
      path: '/session/merchantConditionMonitor',
      name: 'MerchantConditionMonitor',
      component: () => import('/@/views/sessionSettings/conditionMonitor/MerchantConditionMonitor.vue'),
      meta: {
        // affix: true,
        title: '商家客服状态实时监控',
        icon: 'ant-design:control-outlined'
      },
    },
  ],
};

export default serviceKF;
